import { ApiBusinessUnit, ApiClient, ApiNote } from '../../../../../../api/_legacy/generated-api'
import { Attribute, DateDisplay, Fees, Section, Space } from '../../../../../../components/core-v2'
import { Fee } from '../../../../types'
import { StyledCharges, StyledNoteNameHeading, StyledValue } from './primitives'

type Props = {
  asModal: boolean
  businessUnit: ApiBusinessUnit
  client: ApiClient
  fees: Fee[]
  note: ApiNote
}

export const DetailsSummary = ({ asModal, businessUnit, client, fees, note }: Props) => (
  <Section
    mx={asModal ? 5 : 0}
    my={asModal ? 6 : 0}
    pb={asModal ? 3 : 0}
    pt={asModal ? 6 : 0}
    px={asModal ? 5 : 0}
    type="secondary"
  >
    {asModal && <StyledNoteNameHeading>{note?.noteName}</StyledNoteNameHeading>}
    {!asModal && (
      <Attribute name="Name">
        <StyledValue>{note?.noteName}</StyledValue>
      </Attribute>
    )}

    <Attribute name="Client">
      <StyledValue data-private>{client?.clientName}</StyledValue>
    </Attribute>

    <Attribute name="Business unit">
      <StyledValue data-private>{businessUnit?.businessUnitName}</StyledValue>
    </Attribute>

    <Attribute name="Note ID (Stock code)">
      <StyledValue>{note.noteId}</StyledValue>
    </Attribute>

    <Attribute name="Start date">
      <StyledValue>
        <DateDisplay value={note.startDate} />
      </StyledValue>
    </Attribute>

    <Attribute name="End date">
      <StyledValue>
        <DateDisplay value={note.endDate} />
      </StyledValue>
    </Attribute>

    <Attribute name="Distribution processing">
      <StyledValue>{note.dividendProcessing}</StyledValue>
    </Attribute>

    <Attribute name="Note type">
      <StyledValue>{note.taxClassification}</StyledValue>
    </Attribute>

    <Attribute name="Counterparty ID">
      <StyledValue>{note.counterPartyId}</StyledValue>
    </Attribute>

    <Attribute name="Collateral for loan">
      <StyledValue>{note.isCollateralForLoan ? 'Yes' : 'No'}</StyledValue>
    </Attribute>

    {asModal && Array.isArray(fees) && (
      <Space mb={5} mt={6}>
        <StyledCharges>
          <Fees fees={fees} title="Note charges" />
        </StyledCharges>
      </Space>
    )}
  </Section>
)
